import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { API } from "@/lib/api";

/** Full-screen renderer for AI-generated hosted landing pages (/b/:slug). */
export default function HostedSite() {
  const { slug } = useParams();
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/business/site/${slug}`)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then(setHtml)
      .catch(() => setError(true));
  }, [slug]);

  useEffect(() => {
    document.title = `${slug} — hosted on Universtrend`;
  }, [slug]);

  if (error) {
    return (
      <div data-testid="hosted-site-404" className="min-h-screen bg-white text-[#0a0a0a] flex items-center justify-center">
        <div className="text-center px-6">
          <div className="overline text-[#52525b] mb-3">404 · Site not found</div>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter">
            This business doesn&apos;t exist yet.
          </h1>
          <Link to="/" className="hard-shadow inline-block mt-8 border border-black bg-black text-white px-6 py-3 overline">
            Build yours on Universtrend →
          </Link>
        </div>
      </div>
    );
  }

  if (!html) {
    return (
      <div data-testid="hosted-site-loading" className="min-h-screen bg-white flex items-center justify-center font-mono text-xs uppercase tracking-widest text-[#52525b]">
        Loading site…
      </div>
    );
  }

  return (
    <iframe
      data-testid="hosted-site-frame"
      title={slug}
      srcDoc={html}
      sandbox="allow-same-origin allow-popups"
      className="fixed inset-0 w-full h-full border-0"
    />
  );
}
